import router from '../router'
import store from '../store'
import axios from 'axios'
import qs from 'qs'
import _ from 'underscore'

import { Message } from 'iview'

// 创建axios实例
const baseAPI = process.env.VUE_APP_BASE_API
// const baseAPI = 'https://test.agent.pharmconverge.com/'
const service = axios.create({
  baseURL: baseAPI,
  timeout: 50000, // 请求超时时间
  async: true,
  crossDomain: true,
  withCredentials: true
})
// request拦截器
service.interceptors.request.use(config => {
  // 文件处理
  if (config.formData !== undefined && config.formData) {
    config['headers']['Content-Type'] = 'multipart/form-data'
  } else if (config.method === 'POST' || config.method === 'post' || config.method === 'DELETE' || config.method === 'delete') {
    config['headers']['Content-Type'] = 'application/x-www-form-urlencoded'
    config.data = qs.stringify(config.data)
  }
  // 增加token
  if (localStorage.getItem('token')) {
    config.headers.YJHTOKEN = localStorage.getItem('token')
  }
  return config
}, error => {
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (router.history.current.path.toLowerCase().indexOf('login') === -1) {
      const errCode = [-5, 10003, 10004, 10005, 10006, 10007, 10008]
      if (errCode.indexOf(res.code) !== -1) {
        logout()
      }
    } else {
      Message.destroy()
    }
    if (res.code !== 10008) {
      return res
    }
  },
  error => {
    return Promise.reject(error)
  })

var logout = _.debounce(function() {
  Message.destroy()
  Message.info('登录失效')
  // 登录失效清楚token
  localStorage.removeItem('token')
  setTimeout(() => {
    Message.destroy()
    router.push({ name: 'login' })
  }, 500)
}, 500, true)

export default service
